// extracted by mini-css-extract-plugin
export var actionText = "_na-4";
export var container = "_na-0";
export var leftSection = "_na-1";
export var rightSection = "_na-2";
export var settingsButton = "_na-6";
export var settingsIcon = "_na-7";
export var shortcut = "_na-5";
export var shortcutGroup = "_na-3";